export default {
  tokenInvalid: '访问令牌无效',
  uploadSku: '上传的excel包含重复SKU: ',
  blankCode: 'Excel包含空白产品代码',
  blanksCode: '产品代码中有空格: ',
  requestError: '请求错误',
  timeOut: '网关超时',
  code404: '请求失败，状态代码为404',
  loginNameExists: '登录名或邮箱已存在',
  codeInvalid: '授权码无效或已过期',
  accountExpired: '用户帐户已过期',
  notNfcUser: '不是系统指定用户',
  systemError: '系统未知异常',
  sourceFileIsEmpty: '源文件为空',
  sourceDirIsEmpty: '源目录为空',
  configError: 'SKU列表文件路径配置错误',
  insertError: '批量插入NSP SKU错误'
  // repeatSKU: '上传的excel包含重复SKU'
}
